import styled, { css } from 'styled-components';

import { P } from '../../typography';

/* ----------------------------- StyledLabel ----------------------------- */

export const Label = styled(P)(
    ({ theme }) => `
        color: ${theme.sections.page.a};
        font-size: 1rem;
        font-weight: bold;
        line-height: 1;
        padding: 0;
        margin: 0;
    `,
);

export const ErrorText = styled(P)(
    ({ theme }) => `
        color: ${theme.sections.negative};
        font-size: .8rem;
        line-height: 1;
        padding: 0;
        margin: 0;
        text-align: right;
    `,
);

export const LabelWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.3rem;
`;

export const ShowHideIcon = styled.i(
    ({ theme }) => `
        color: ${theme.sections.medium};
        position: absolute;
        right: 0.45rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    `,
);

export const InputWrapper = styled.div`
    position: relative;
`;

export const TextInput = styled.input<{ canToggleTypeAttribute?: boolean }>(
    ({ theme, canToggleTypeAttribute }) => `
        &::-webkit-input-placeholder {
            /* Chrome/Opera/Safari */
            color: ${theme.sections.dark}80;
        }
        &::-moz-placeholder {
            /* Firefox 19+ */
            color: ${theme.sections.dark}80;
        }
        &:-ms-input-placeholder {
            /* IE 10+ */
            color: ${theme.sections.dark}80;
        }
        &:-moz-placeholder {
            /* Firefox 18- */
            color: ${theme.sections.dark}80;
        }

        border: 0.06rem solid ${theme.sections.mediumLight};
        background-color: ${theme.sections.light};
        color: ${theme.sections.dark};
        padding: 0.65rem 0.5rem;
        ${canToggleTypeAttribute ? `padding-right: 2.5rem;` : ``}
        border-radius: 0.3rem;
        width: 100%;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;

        font-size: 1rem;
        @media screen and (min-width: 48rem) {
            font-size: 1.125rem;
        }

        &:focus,
        &:active {
            border: 0.06rem solid ${theme.sections.page.feature};
        }

        &:disabled {
            -webkit-appearance: none;
            opacity:1;
        }
    `,
);

export const RequiredSpan = styled.span(
    ({ theme }) => `
    color: ${theme.sections.negative};
`,
);

export const StyledLabel = styled.label<{ hasError?: boolean }>(
    ({ theme, hasError = false }) => [
        css`
            padding-bottom: 1.5rem;
            display: block;
            position: relative;
            outline: none;
        `,
        hasError &&
            css`
                ${TextInput} {
                    border: 0.06rem solid ${theme.sections.negative};
                }

                ${Label} {
                    color: ${theme.sections.negative};
                }
            `,
    ],
);
